
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curso/[course]",
      function () {
        return require("private-next-pages/curso/[course]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curso/[course]"])
      });
    }
  